import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@rebass/emotion';
import { css } from '@emotion/core';
import { useParams } from 'react-router-dom';

import { H2, H3 } from '@app/shop/components/typography';
import Card from '@app/components/Card';
import { Button } from '@app/shop/components/Button';

import {
  nextStepsRowStyles,
  NextStepsGrid,
  neutralCardStyles,
  nextStepImageStyles,
} from './Success.styles';
import messages from './Success.messages';
import nativeAccess1x from './assets/native-access-1x.png';
import nativeAccess2x from './assets/native-access-2x.png';

const NextSteps: FC<{ productName: string }> = ({ productName }) => {
  const { language = 'en' } = useParams<{ language?: string }>();
  const nativeAccessLink = `https://www.native-instruments.com/${language}/specials/native-access/`;

  return (
    <div data-testid="order-next-steps">
      <H2
        css={css`
          margin-bottom: 1.2rem;
        `}
      >
        <FormattedMessage {...messages.nextSteps} />
      </H2>

      <Card css={neutralCardStyles}>
        <NextStepsGrid>
          <Box textAlign="center" px={[20]} css={nextStepsRowStyles}>
            <H3>
              {productName ? (
                <FormattedMessage
                  data-testid="native-access-product-title"
                  {...messages.getViaNativeTitle}
                  values={{ product: productName }}
                />
              ) : (
                <FormattedMessage
                  data-testid="native-access-generic-title"
                  {...messages.getNativeAccess}
                />
              )}
            </H3>
            <p>
              <FormattedMessage {...messages.getViaNativeDescription} />
            </p>

            <a href={nativeAccessLink} data-testid="native-access-link">
              <Button
                type="secondary"
                css={css`
                  margin-top: 0.55rem;
                `}
              >
                <FormattedMessage {...messages.learnMore} />
              </Button>
            </a>
          </Box>

          <img
            srcSet={`
             ${nativeAccess1x} 1x,
             ${nativeAccess2x} 2x`}
            src={nativeAccess1x}
            alt=""
            css={nextStepImageStyles}
          />
        </NextStepsGrid>
      </Card>
    </div>
  );
};

export default NextSteps;
